import React from 'react';
import Modal from 'react-modal';

import i18 from '../../../i18';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

class SupplierRuleViewModal extends React.Component {

    getDisplayValue = (value, suffix) => {
        if (
            value === null
            || typeof value === 'undefined'
            || value === ''
        ) {
            return '-';
        }

        return suffix
            ? String(value) + suffix
            : value;
    };

    getCollectorCode = () => {
        const {rule} = this.props;

        if (
            rule.vatCollectorCode
            && rule.vatCollectorCode.code
        ) {
            return rule.vatCollectorCode.code;
        }

        if (
            rule.vatCode
            && rule.vatCode.code
        ) {
            return rule.vatCode.code;
        }

        if (rule.vat_collector_code) {
            return rule.vat_collector_code;
        }

        return '-';
    };

    getRuleType = () => {
        const {rule} = this.props;

        return (
            rule.type_label
            || rule.typeLabel
            || rule.type
            || '-'
        );
    };

    renderRow = (label, value) => {
        return (
            <tr>
                <td>{label}</td>
                <td>{this.getDisplayValue(value)}</td>
            </tr>
        );
    };

    render() {
        const {
            rule,
            closeModal,
        } = this.props;

        if (!rule) {
            return null;
        }

        return (
            <Modal
                isOpen={true}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel={i18.COMMON._showRuleText}
            >
                <div className="modal-body">
                    <table className="table table-striped table-aibook-no-border">
                        <tbody>
                        {this.renderRow('Azonosító', '#' + rule.id)}
                        {this.renderRow('Szállító neve', rule.supplier_name)}
                        {this.renderRow('Tétel megnevezés', rule.item_name)}
                        {this.renderRow(i18.SUPPLIER._positionNumberCountry, rule.position_number_country)}
                        {this.renderRow(i18.SUPPLIER._orderNumberStat, rule.order_number_stat)}
                        {this.renderRow('Főkönyv szám', rule.main_bookkeeping_number)}
                        {this.renderRow('ÁFA százalék', this.getDisplayValue(rule.vat, '%'))}
                        {this.renderRow('ÁFA gyűjtő kód', this.getCollectorCode())}
                        {this.renderRow('ÁFA fők. szám', rule.vat_degree)}
                        {this.renderRow(i18.COMMON._typeOfRule, this.getRuleType())}
                        {this.renderRow(i18.COMMON._position, rule.position)}
                        {this.renderRow(i18.COMMON._updatedAt, rule.updated_at)}
                        </tbody>
                    </table>

                    <div className="text-center">
                        <button
                            type="button"
                            onClick={closeModal}
                            className="btn btn-danger btn-sm"
                        >
                            {i18.COMMON._close}
                        </button>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default SupplierRuleViewModal;


// WEBPACK FOOTER //
// ./src/components/supplier/rules/RuleViewModal.js